export default __webpack_public_path__ + "static/media/15-BB-(3-2).901e3472.jpg";